import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import BrandedLeading from 'ui/src/components/BrandedLeading';
import addUrlHostName from 'ui/src/utils/addUrlHostname';
import type { FooterMenu } from '../../data/FooterMenuType';
import useFooterThemes from './themes';

const CAREERS = 'Careers';
const CARRERS_LINK = 'https://www.bairesdev.com/join-us/';

export type MenuOptionsProps = {
  menu: FooterMenu;
  classes: string;
  withFullStops?: boolean;
};

export default function MenuOptions({ menu, classes, withFullStops }: MenuOptionsProps) {
  const { footerMenuListClasses, footerMenuListItemClasses, footerMenuTitleClasses } = useFooterThemes();

  return (
    <div className={classes}>
      <ul>
        <li className={twMerge(footerMenuTitleClasses)}>
          {/* TODO -> Hardcoded, the link information should come from backend */}
          <BrandedLeading
            as={menu.title.includes(CAREERS) ? 'a' : 'strong'}
            hrefLink={menu.title.includes(CAREERS) ? CARRERS_LINK : undefined}
            addBrandedFullStop={withFullStops}
          >
            {menu.title}
          </BrandedLeading>
        </li>
        {menu.menuItems.map((menuItem) => (
          <li key={menuItem.id} className={twMerge(footerMenuListClasses)}>
            <a
              href={addUrlHostName(menuItem.path)}
              rel={menuItem.rel || undefined}
              className={twMerge(footerMenuListItemClasses)}
            >
              {menuItem.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
